import React from 'react'

interface LayoutContext {
  linkPrefix: string
}

export const MainLayoutContext = React.createContext<LayoutContext>({
  linkPrefix: '',
})
